import React from "react";
import Img from "../../assets/img/store_img-default.svg";
import { Carousel } from "react-bootstrap";

function Carrossel({ images }) {
  return (
    <div className=" h-100 border rounded-3 overflow-hidden" style={{ maxHeight: "396px", maxWidth: "518" }}>
      <Carousel className="d-flex justify-content-center align-items-center">
        {images ? (
          images?.map((img, index) => (
            <Carousel.Item key={index}>
              <img
                className="d-block w-100"
                style={{ objectFit: "contain", height: "100%", maxHeight: "400px" }}
                src={img.url}
                alt="First slide"
              />
            </Carousel.Item>
          ))
        ) : (
          <Carousel.Item>
            <div className="d-flex align-items-center justify-content-center">
              <img className="d-block" src={Img} alt="No pictures" />
            </div>
          </Carousel.Item>
        )}
      </Carousel>
    </div>
  );
}

export default Carrossel;
